import icn_dot_online from "assets/images/icons/icn_dot_online.svg";
import icn_dot_offline from "assets/images/icons/icn_dot_offline.svg";
import icn_dot_dormant from "assets/images/icons/icn_dot_dormant.svg";
import icn_dot_warning from "assets/images/icons/icn_dot_warning.svg";

// Chart option
export const chartOption = {
  container: null,
  editable: false,
  mode: "full",
  view: {
    engine: "svg",
    line_style: "curve",
    line_width: 4,
    line_color: "black",
    // hmargin: 50,
    // vmargin: 50,
    draggable: true,
  },
  layout: {
    cousin_space: 0,
    hspace: 100,
    vspace: -20,
  },
};

export const lineOption = {
  COLOR: '#727CA4',
  WIDTH: 3,
  DASH: 'dash'
}

export const deviceTypeOption = {
  UNKNOWN: undefined,
  SWITCH: "switch",
  GATEWAY: "gateway",
  ROUTER: "router",
  ACCESS_POINT: "ap",
  CLIENT: "client",
};

export const deviceStateOption = {
  ONLINE: "online",
  OFFLINE: "offline",
  WARNING: "warning",
  DORMANT: "dormant",
};

export const deviceStateDictionary = {
  online: {
    label: "Online",
    icon: icn_dot_online,
  },
  offline: {
    label: "Offline",
    icon: icn_dot_offline,
  },
  warning: {
    label: "Warning",
    icon: icn_dot_warning,
  },
  dormant: {
    label: "Dormant",
    icon: icn_dot_dormant,
  },
}

export const deviceStatisticOption = {
  ONLINE: "online",
  OFFLINE: "offline",
  WIRED: "wired",
  WIRELESS: "wireless",
};

// Search option
export const filterOption = {
  keyword: "",
  model: {
    options: [],
  },
  state: {
    options: [],
  },
  tag: {
    options: [],
  },
};

export const eyeOption = {
  deviceName: true,
  clientName: true,
  macAddress: true,
  allClients: true,
  wired: true,
  wireless: true,
  onlineClients: true,
  offlineClients: true,
};

// Port option
export const portType = {
  fiber: "fiber",
  cooper: "cooper",
};

export const portState = {
  error: "error",
  disabled: "disabled",
  disconnected: "disconnected",
  "10g": "10g",
  "2.5/5g": "2.5/5g",
  "1g": "1g",
  "10/100m": "10/100m",
};